import { Symmetric } from "../misc.js";
import { getSubtle, randomBytes } from "./utils.js";
export async function encrypt(iv, key, clearText) {
    return getSubtle()
        .importKey("raw", key, Symmetric.algorithm, false, ["encrypt"])
        .then((cryptoKey) => getSubtle().encrypt({ iv, ...Symmetric.algorithm }, cryptoKey, clearText))
        .then((cipher) => new Uint8Array(cipher));
}
export async function decrypt(iv, key, cipherText) {
    return getSubtle()
        .importKey("raw", key, Symmetric.algorithm, false, ["decrypt"])
        .then((cryptoKey) => getSubtle().decrypt({ iv, ...Symmetric.algorithm }, cryptoKey, cipherText))
        .then((clear) => new Uint8Array(clear));
}
export function generateIv() {
    return randomBytes(Symmetric.ivSize);
}
//# sourceMappingURL=symmetric.js.map